import { LoadState } from "../../constants/enums";
import { IUser, IUsersState } from "./userProfile.types";

export const initialUser: IUser = {
  first_name: "",
  personal_email: "",
  role_name: "",
  role_uuid: "",
  user_uuid: "",
  last_name: null,
  job_title: null,
  user_type: null,
  assigned_phone_number: null,
  shared_email: null,
  mobile: null,
  home_phone: null,
  linkedin_profile: null,
  hire_date: null,
  last_day_at_work: null,
  branch: null,
  department_name: null,
  department_uuid: null,
  fax: null,
  date_of_birth: null,
  mother_maiden_name: null,
  photo: null,
  signature: null,
  street_address: null,
  unit_or_suite: null,
  city: null,
  province_or_state: null,
  postal_code: null,
  country: null,
  languages_known: null,
  documents: null,
  manager_uuid: null,
  branch_name: "",
  bank_name: null,
  bank_account_number: null,
  bank_ifsc_code: null,
  bank_branch: null,
  father_name: null,
  mother_name: null,
  spouse_name: null,
  father_contact_no: null,
  mother_contact_no: null,
  spouse_contact_no: null,
  marital_status: null,
  branch_uuid: "",
  attachment: [],
  full_name: "",
  attachment_name: "",
  affiliated_billing_company_uuids: [],
  role_value: "",
  manager_name: "",

  status: "ACTIVE",

  full_name_as_per_aadhaar_card: null,
  full_name_as_per_pan_card: null,
  gender_as_in_aadhaar_card: null,
  pf_account_name: null,
  pf_details_available: null,
  pf_establishment_id: null,
  pf_number: null,
  employee_esi_number: null,
  enrollment_number: null,
  esi_details_available: null,
  esi_eligible: null,
  esi_number: null,
  is_physically_handicapped: 0,
  pan_card_available: 0,
  pan_number: null,
  aadhaar_number: null,
  address_as_in_aadhaar_card: null,

  dob_in_aadhaar_card: null,
  dob_in_pan_card: null,
};

export const initialUserProfileState: IUsersState = {
  users: {
    data: [],
    totalNumberOfRecords: 0,
    loading: LoadState.NotLoaded,
    user: initialUser,
    userLoading: LoadState.NotLoaded,
    error: null,
  },
};
